import { BonusTypeId, BonusTypeType } from '@/enums/bonusTypeId';

export function getBonusTypeColor(id: BonusTypeType) {
  switch (id?.toString()) {
    case BonusTypeId.Bet?.toString():
      return '#3FED87';
    case BonusTypeId.Ticket?.toString():
      return '#FFE72F';
    case BonusTypeId.Spin?.toString():
      return '#ED1F26';
  }
}
